import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-pricing',
  templateUrl: './pricing.component.html',
  styleUrls: ['./pricing.component.scss'],
})
export class PricingComponent implements OnInit {
  showForm = false;

  orgType: number;

  constructor(private router: Router) { }

  ngOnInit() {
  }

  startPricing() {
    if (this.orgType == 1 || this.orgType == 2) {
      this.router.navigate(['/pricing/pricing-form'], { queryParams: { o: this.orgType } });
    } else if (this.orgType == 3) {
      this.router.navigate(['/partnership']);
    } else {
      this.router.navigate(['/home']);
    }
  }
}
